import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { useCurrentEnterpriseId } from '@mews-commander/core';

export const useProductsGetAll = (serviceIds: string[]) => {
    const currentEnterpriseId = useCurrentEnterpriseId();

    return useRepositorySuspenseQuery('products', 'getAll', {
        enterpriseIds: [currentEnterpriseId],
        serviceIds,
        extent: {
            baseProducts: false,
            productCategories: true,
        },
    });
};
